module.exports = __webpack_public_path__ + "static/media/pig.4f9a77c2.svg";